import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import "modules/CommunicationSettings/CustomerCom.scss";

import type { CommunicationSetting } from "models";

type ServiceTrackerProps = {
  tabId: string;
};

const FormHelper = createFormHelper<CommunicationSetting>();

export const ServiceTracker = ({ tabId }: ServiceTrackerProps) => {
  const { t } = useTranslation();

  const { watch } = FormHelper.useFormContext();

  const isStarRatingEnabled = watch("is_star_rating_enabled");

  return (
    <Element name={tabId} className="customer-com-wrapper">
      <div className="service-tracker-header">
        <h3>{t("v8_service_tracker", "Service Tracker")}</h3>
        <FormHelper.Field.Checkbox name="is_service_tracker_enabled" label={t("v8_enabled", "Enabled")} />
      </div>
      <div>
        <Form.Group className="mt-16">
          <Form.Field width={8}>
            <label>{t("v8_service_tracker_check_in_message", "Check in message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_check_in_message" />
          </Form.Field>

          <Form.Field width={8}>
            <label>{t("v8_service_tracker_check_in_car_diagnostic_message", "Check in - Car diagnostic message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_check_in_car_diagnostic_message" />
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-16">
          <Form.Field width={8}>
            <label>{t("v8_service_tracker_car_diagnostic_message", "Car diagnostic message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_car_diagnostic_message" />
          </Form.Field>

          <Form.Field width={8}>
            <label>{t("v8_service_tracker_car_diagnostic_waiting_for_approval_message", "Car diagnostic - Waiting for approval message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_car_diagnostic_waiting_for_approval_message" />
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-16">
          <Form.Field width={8}>
            <label>{t("v8_service_tracker_waiting_for_approval_message", "Waiting for approval message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_waiting_for_approval_message" />
          </Form.Field>

          <Form.Field width={8}>
            <label>{t("v8_service_tracker_waiting_for_approval_repair_items_message", "Waiting for approval - Repair items message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_waiting_for_approval_repair_items_message" />
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-16">
          <Form.Field width={8}>
            <label>{t("v8_service_tracker_repair_items_message", "Repair items message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_repair_items_message" />
          </Form.Field>

          <Form.Field width={8}>
            <label>{t("v8_service_tracker_final_check_message", "Final check message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_final_check_message" />
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-16">
          <Form.Field width={8}>
            <label>{t("v8_service_tracker_picked_up_car_message", "Picked up car message")}</label>
            <FormHelper.Field.TextArea name="service_tracker_picked_up_car_message" />
          </Form.Field>
        </Form.Group>

        <h3 className="title mt-20">{t("v8_rating", "Rating")}</h3>

        <Form.Group className="mt-12">
          <Form.Field width={16}>
            <FormHelper.Field.Checkbox name="is_star_rating_enabled" label={t("v8_enable_user_rating", "Enable user rating")} />
          </Form.Field>
        </Form.Group>

        {Boolean(isStarRatingEnabled) && (
          <>
            <Form.Group className="mt-12">
              <Form.Field width={8}>
                <label>{t("v8_star_rating_question", "Star rating - Question")} #1</label>
                <FormHelper.Field.Input
                  inputProps={{ fluid: true, placeholder: `${t("v8_star_rating_question", "Star rating - Question")} #1` }}
                  name="star_rating_experience_message"
                />
              </Form.Field>

              <Form.Field width={8}>
                <label>{t("v8_star_rating_question", "Star rating - Question")} #2</label>
                <FormHelper.Field.Input
                  inputProps={{ fluid: true, placeholder: `${t("v8_star_rating_question", "Star rating - Question")} #2` }}
                  name="star_rating_service_message"
                />
              </Form.Field>
            </Form.Group>

            <Form.Group className="mt-12">
              <Form.Field width={8}>
                <label>{t("v8_star_rating_question", "Star rating - Question")} #3</label>
                <FormHelper.Field.Input
                  inputProps={{ fluid: true, placeholder: `${t("v8_star_rating_question", "Star rating - Question")} #3` }}
                  name="star_rating_speed_message"
                />
              </Form.Field>
            </Form.Group>
          </>
        )}
      </div>
    </Element>
  );
};
